import { intersect, string, struct } from 'io-ts/Decoder';

import { Params as BaseParams } from '../../../comment/update/Params';

export const Params = intersect(BaseParams)(
	struct({
		variationId: string,
	})
);
